import { AppRegistry } from 'react-native';
import App from "./src/App";
import AppJson from './app.json';
import "./i18n";
import "./web/global.css";
import { en, es, registerTranslation } from "react-native-paper-dates";
import { SingleSignOn } from './src/shared/SingleSignOn';

registerTranslation("en", en);
registerTranslation("es", es);

require.context('./src/images', true, /\.(svg|png|jpe?g|gif)$/);

if (SingleSignOn.IsRedirect()) {
    SingleSignOn.Redirect();
} else {
    AppRegistry.registerComponent(AppJson.name, () => App);
    AppRegistry.runApplication(AppJson.name, {
        rootTag: document.getElementById('root'),
    });
}